import { registerQuery } from '@adornis/baseql/metadata/register.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { AdornisFile } from '@adornis/file-utils/db/files.js';
import { loadAndAssert } from '../authz/access.js';

export const getFileByIDQuery = registerQuery({
  operationName: 'getFileByIDQuery',
  type: () => AdornisFile,
  params: [{ name: 'fileId', type: () => String }],
  resolve:
    (fileId: string) =>
    async (_gqlFields: BaseQLSelectionSet<AdornisFile>): Promise<AdornisFile> =>
      loadAndAssert<AdornisFile>(AdornisFile, fileId, 'read'),
});
